<agpr-take-over-panel
    [id]="id"
    [header]="'Briefings.analysis.generateAnalysis'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [maxPanelWidth]="1600"
    [minPanelWidth]="800"
    [responsiveWidth]="true"
    [width]="80"
    class="agpr-generateAnalysisDialog-overlay"
    (visibleChange)="close()"
>
    <div class="agpr-generateAnalysisDialog">
        <div class="agpr-generateAnalysisDialog-leftContainer">
            <agpr-scroll-panel>
                <div class="agpr-generateAnalysisDialog-left">
                    <div>
                        <agpr-analysis-block-monitoring-source-picker-field
                            #analysisMonitoringPicker
                            [id]="id + '-sourcePickerField'"
                            [field]="sourceField"
                            [dynamicDisplayDate]="false"
                            [value]="dataSource"
                            (changes)="sourceSelected($event)"
                            [showHiddenOption]="true"
                        ></agpr-analysis-block-monitoring-source-picker-field>
                    </div>
                    <div class="agpr-generateAnalysisDialog-tabs">
                        <agpr-tabs
                            [selectedTabIndex]="selectedTabIndex"
                            (selectedTabIndexChange)="tabIndexChange($event)"
                            [addNewTab]="'Briefings.analysis.customInsight.new.click'"
                            (addNewTrigger)="newCustomInsight()"
                            [addNewDisabled]="customInsight?.isEmpty() && (selectedCoverageInsightType === coverageInsightTypes.CUSTOM)"
                        >
                            @if (openAiPermission && selectedTabIndex == 1 ) {
                                <agpr-button
                                    tabActions
                                    [id]="id + '_customInsightTab_customPrompt_button'"
                                    icon="fa-regular fa-duotone fa-gear"
                                    [style]="buttonTypes.icon"
                                    tooltip="CustomPrompt.prompt.list.section.title"
                                    (click)="openCustoPromptDialog()"
                                ></agpr-button>
                            }
                            <agpr-tab
                                [id]="'analysis.analysisType'"
                                [heading]="'Briefings.analysis.analysisType'"
                            >
                                <!-- eslint-disable @angular-eslint/template/interactive-supports-focus-->
                                @if (selectedCoverageInsightType) {
                                    <div
                                        class="agpr-generateAnalysisDialog-container"
                                        [id]="id + '_insight_container'"
                                    >
                                        <div
                                            class="agpr-generateAnalysisDialog-header"
                                        >
                                            <span>
                                                {{'Mention.workbench.insights.prompt' | localize}}
                                            </span>
                                        </div>
                                        <div class="agpr-generateAnalysisDialog-insights-main-promptHeader">
                                            <agpr-button
                                                [style]="buttonTypes.icon"
                                                [icon]="'fa-regular fa-arrow-left'"
                                                [id]="id + '_insight_backToPrompts'"
                                                (click)="backToPrompts()"
                                            ></agpr-button>
                                            <span>{{ 'Mention.workbench.insights.system.' + selectedCoverageInsightType | localize }}</span>
                                        </div>

                                        <ng-container>
                                            <agpr-coverage-insights-form
                                                [value]="coverageInsights"
                                                (formChanged)="changedValue($event)"
                                            ></agpr-coverage-insights-form>
                                        </ng-container>
                                    </div>
                                } @else {
                                    <ul
                                        [id]="'analysisList'"
                                        agprListKeyboardNavigation
                                        [list]="systemInsights"
                                    >
                                        @for (item of systemInsights; track item) {
                                            @let systemItemId = id + '_systemAnalysisList_' + item;
                                            <li
                                                [id]="systemItemId"
                                                class="agpr-generateAnalysisDialog-item"
                                                (keydown.enter)="selectAnalysisType(item)"
                                                (click)="selectAnalysisType(item)"
                                            >
                                                <agpr-prompt-card
                                                    [id]="systemItemId"
                                                    [title]="'Mention.workbench.insights.system.' + item"
                                                    [tooltipInfo]="'Mention.workbench.insights.system.tooltip.' + item"
                                                >
                                                </agpr-prompt-card>
                                            </li>
                                        }
                                    </ul>
                                }
                                <!-- eslint-enable @angular-eslint/template/interactive-supports-focus-->

                            </agpr-tab>
                            <agpr-tab
                                [id]="'analysis.custom'"
                                [heading]="'Briefings.analysis.customAnalysis'"
                            >
                                @if (selectedCoverageInsightType) {
                                    <div
                                        class="agpr-generateAnalysisDialog-container"
                                        [id]="id + '_customInsight_container'"
                                    >
                                        <div
                                            class="agpr-generateAnalysisDialog-header"
                                        >
                                            <span>
                                                {{'Mention.workbench.insights.prompt' | localize}}
                                            </span>
                                        </div>
                                        <div class="agpr-generateAnalysisDialog-insights-main-promptHeader">
                                            <agpr-button
                                                [style]="buttonTypes.icon"
                                                [icon]="'fa-regular fa-arrow-left'"
                                                [id]="id + '_customInsight_backToPrompts'"
                                                (click)="backToPrompts()"
                                            ></agpr-button>
                                            <span>{{ 'Mention.workbench.insights.system.' + selectedCoverageInsightType | localize }}</span>
                                        </div>

                                        @if (customInsightSaveTooltip) {
                                            <agpr-message
                                                [severity]="messageSeverityEnum.error"
                                            >
                                                {{ customInsightSaveTooltip | localize }}
                                            </agpr-message>
                                        }

                                        <ng-container>
                                            <agpr-coverage-insights-form
                                                [value]="coverageInsights"
                                                [customInsight]="customInsight"
                                                (customFormChanged)="changedCustomValue($event)"
                                            ></agpr-coverage-insights-form>
                                        </ng-container>
                                    </div>
                                } @else {
                                    <ul
                                        [id]="id + '_customAnalysisList'"
                                        agprListKeyboardNavigation
                                        [list]="customInsights"
                                    >
                                        @for (item of customInsights; track item.id) {
                                            @let customItemId = id + '_customAnalysisList_' + item.id;
                                            <li
                                                [id]="customItemId"
                                                class="agpr-generateAnalysisDialog-item agpr-contextMenu-parent"
                                                tabindex="-1"
                                                (keydown.enter)="selectCustomInsight(item)"
                                                (click)="selectCustomInsight(item)"
                                            >
                                                <agpr-prompt-card
                                                    [id]="customItemId"
                                                    [title]="item.name"
                                                >
                                                </agpr-prompt-card>
                                                <div class="agpr-contextMenu top right">
                                                    <agpr-button
                                                        [style]="buttonTypes.contextMenu"
                                                        [id]="item.id + '_deleteInsight'"
                                                        icon="fa-regular fa-duotone fa-trash-can"
                                                        [tooltip]="'Ai.analysis.customInsight.delete' | localize"
                                                        (keydown.enter)="deleteCustomInsight($event, item)"
                                                        (click)="deleteCustomInsight($event, item)"
                                                    >
                                                    </agpr-button>
                                                </div>
                                            </li>
                                        }

                                        @if (!customInsights?.length) {
                                            <li
                                                [id]="id + '_customAnalysisList_newCustomInsight'"
                                                class="agpr-generateAnalysisDialog-item"
                                                tabindex="-1"
                                                (keydown.enter)="newCustomInsight()"
                                                (click)="newCustomInsight()"
                                            >
                                                <agpr-prompt-card
                                                    [id]="id + '_customAnalysisList_newCustomInsight'"
                                                    [title]="'Briefings.analysis.customInsight.new'"
                                                >
                                                </agpr-prompt-card>
                                            </li>
                                        }
                                    </ul>
                                }
                            </agpr-tab>
                        </agpr-tabs>
                    </div>
                </div>
            </agpr-scroll-panel>
        </div>

        <div class="agpr-generateAnalysisDialog-rightContainer">
            <agpr-scroll-panel>
                <div class="agpr-generateAnalysisDialog-right">
                    <agpr-scroll-panel>
                        <agpr-rich-text-editor-ck
                            #insightEditor
                            [richTextEditorConfig]="ckEditorConfig"
                            [(ngModel)]="generatedContent"
                        ></agpr-rich-text-editor-ck>
                    </agpr-scroll-panel>
                </div>
            </agpr-scroll-panel>
        </div>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            (click)="close()"
            [label]="'Core.button.cancel'"
            [style]="buttonTypes.secondary"
            [id]="id+'_cancelButton'"
        ></agpr-button>

        @if (selectedCoverageInsightType) {
            <div class="agpr-generateAnalysisDialog-insights-main-insightActions">
                <div class="agpr-generateAnalysisDialog-spacer"></div>
                @if (selectedCoverageInsightType === coverageInsightTypes.CUSTOM) {
                    <agpr-button
                        class="agpr-generateAnalysisDialog-buttonSpace"
                        label="Briefings.analysis.customAnalysis.save"
                        [disabled]="!customInsightValid || customInsight?.equals(customInsightCopy)"
                        [style]="buttonTypes.primaryB"
                        [tooltip]="(!customInsightValid && customInsightSaveTooltip) ? customInsightSaveTooltip : 'Briefings.analysis.customAnalysis.save.tooltip'"
                        [id]="id + '_insight_saveCustomInsight'"
                        (click)="saveCustomInsight()"
                    ></agpr-button>
                    @if (customInsight?.id) {
                        <agpr-button
                            class="agpr-generateAnalysisDialog-buttonSpace"
                            label="Briefings.analysis.customAnalysis.saveAs"
                            [disabled]="!customInsightValid"
                            [style]="buttonTypes.primaryB"
                            [tooltip]="(!customInsightValid && customInsightSaveTooltip) ? customInsightSaveTooltip : 'Briefings.analysis.customAnalysis.saveAs.tooltip'"
                            [id]="id + '_insight_saveAsCustomInsight'"
                            (click)="saveAsCustomInsight()"
                        ></agpr-button>
                    }
                    <agpr-button
                        label="Mention.workbench.insights.generateInsight"
                        [disabled]="!promptIsValid || !customInsight?.id || !customInsight?.equals(customInsightCopy)"
                        [style]="buttonTypes.primaryB"
                        [tooltip]="promptGenerateTooltip"
                        [id]="id + '_insight_generateInsight'"
                        (click)="generateInsight()"
                    ></agpr-button>
                } @else {
                    <agpr-button
                        label="Mention.workbench.insights.generateInsight"
                        [disabled]="!promptIsValid"
                        [style]="buttonTypes.primaryB"
                        [tooltip]="promptGenerateTooltip"
                        [id]="id + '_insight_generateInsight'"
                        (click)="generateInsight()"
                    ></agpr-button>
                }
            </div>
        }

    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            (click)="apply()"
            [label]="'Core.button.apply'"
            [tooltip]="!generatedContent ? 'Briefings.analysis.mustGenerateAnalysis' : ''"
            [disabled]="!generatedContent"
            [style]="buttonTypes.primary"
            [id]="id+'_applyButton'"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
